module.exports = __webpack_public_path__ + "img/ag.0c113ee4.svg";